module.exports = __webpack_public_path__ + "static/media/camera_.5e75afa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/camera_.png
// module id = 647
// module chunks = 0 1